import { ApplicationRef, Component, ComponentRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-inspection',
  templateUrl: './multiple-button.component.html',
  styleUrls: ['./multiple-button.component.scss'],
})
export class MultipleButtonComponent implements OnInit {
  constructor(private appRef: ApplicationRef) {}

  componentRef: ComponentRef<MultipleButtonComponent>;

  @ViewChild('childModal', { static: true }) public childModal: ModalDirective;

  buttonOneClickCallback: () => void;
  buttonTwoClickCallback: () => void;
  cancelCallback: () => void;
  message: string;
  messageHtml: string;
  buttonOne: string;
  buttonTwo: string;
  maxWidth: boolean;
  buttonOneColor: string;
  buttonTwoColor: string;
  cancelColor: string;

  ngOnInit() {
    this.childModal.onHidden.subscribe(x => {
      if (x.dismissReason === 'esc' || x.dismissReason === 'backdrop-click') {
        this.cancel();
      }
    });
  }

  destroy() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }

  show(options: {
    message?: string;
    messageHtml?: string;
    buttonOne?: string;
    buttonTwo?;
    buttonOneClicked?: () => void;
    buttonTwoClicked?: () => void;
    canceled?: () => void;
    maxWidth?: boolean;
    buttonOneColor?: string;
    buttonTwoColor?: string;
    cancelColor?: string;
  }) {
    this.buttonOneClickCallback = options.buttonOneClicked;
    this.buttonTwoClickCallback = options.buttonTwoClicked;
    this.cancelCallback = options.canceled;
    this.message = options.message;
    this.messageHtml = options.messageHtml;
    this.buttonOne = options.buttonOne;
    this.buttonOneColor = options.buttonOneColor || '#2763cd';
    this.buttonTwo = options.buttonTwo;
    this.buttonTwoColor = options.buttonTwoColor || '#2763cd';
    this.maxWidth = options.maxWidth;
    this.cancelColor = options.cancelColor;
    setTimeout(() => {
      this.childModal.show();
    }, 0);
  }

  buttonOneClick() {
    this.childModal.hide();
    this.destroy();
    this.buttonOneClickCallback && this.buttonOneClickCallback();
  }

  buttonTwoClick() {
    this.childModal.hide();
    this.destroy();
    this.buttonTwoClickCallback && this.buttonTwoClickCallback();
  }

  cancel() {
    this.childModal.hide();
    this.destroy();
    this.cancelCallback && this.cancelCallback();
  }
}
